import classNames from 'classnames';
import { Button } from 'app/agriculture/components/Button/Button';
import { AssetIcon } from 'app/agriculture/icons/components';
import { useRouteActions } from 'app/agriculture/router/useRouteActions';
import { AddNewEntities, isEntityType } from 'app/agriculture/models/Entities';

export function AddNewButtonContent({ handleClose }: { handleClose: () => void }) {
    const routeActions = useRouteActions();

    return (
        <div className="AddNewButton__content">
            {AddNewEntities.map((assetType) => (
                <Button
                    key={assetType}
                    id={`item-${assetType.replace(' ', '').toLowerCase()}`}
                    onClick={() => {
                        handleClose();
                        if (isEntityType(assetType)) routeActions.create(assetType);
                    }}
                    variant="textonly"
                    className={classNames(
                        'AddNewButton__button',
                        `AddNew${assetType.replace(' ', '')}Button`,
                    )}
                    startIcon={<AssetIcon name={assetType} />}
                    text={assetType}
                />
            ))}
        </div>
    );
}
